import { render } from "./BaseButtons.vue?vue&type=template&id=4df102a0"
import script from "./BaseButtons.vue?vue&type=script&lang=ts"
export * from "./BaseButtons.vue?vue&type=script&lang=ts"
script.render = render

export default script